import { SITE } from "@/config/site";
import { useLanguage } from "@/i18n/LanguageContext";

// Mensagem de erro de envio, visível no próprio formulário. O email aparece como ligação.
export default function FormError() {
  const { t } = useLanguage();
  const [before, after = ""] = t("form.error").split("{email}");
  return (
    <div role="alert" data-testid="form-error" className="border border-[#C98B7B]/50 bg-[#C98B7B]/10 p-4 text-sm text-[#F0D9D2] font-light leading-relaxed">
      {before}
      <a href={`mailto:${SITE.email}`} className="underline underline-offset-4 text-white hover:text-[#C2A675] transition-colors">{SITE.email}</a>
      {after}
    </div>
  );
}
